import React from 'react';
import DocsGate from '../../pages/api-docs/DocsGate';

/**
 * Protected Route Component for API Documentation
 * Wraps documentation pages with access control
 */
const ProtectedDocsRoute = ({ children }) => {
  return <DocsGate>{children}</DocsGate>;
};

export default ProtectedDocsRoute;
